/** Generated by scripts/build-editor-fonts.py — do not edit. */

/** x-height (em) of each self-hosted text face (fonts/web/text), for the size of formulas */
export const TEXT_X_HEIGHT: Record<string, number> = {
  'newcm': 0.431,
  'libertinus': 0.431,
  'stix2': 0.473,
  'xits': 0.45,
  'termes': 0.45,
  'pagella': 0.469,
  'bonum': 0.485,
  'schola': 0.466,
  'dejavu': 0.519,
  'garamond': 0.405,
  'crimson': 0.4199,
  'charis': 0.4819,
  'xcharter': 0.481,
  'erewhon': 0.461,
  'kp': 0.441,
  'concrete': 0.458,
  'oldstandard': 0.456,
  'neohellenic': 0.387,
  'fira': 0.527,
  'lato': 0.5065,
  'notosans': 0.536,
  'plex': 0.516,
  'luciole': 0.545,
  'pennstander': 0.5355,
  'arsenal': 0.5,
  'pl46': 0.4497
};
